import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';

import { useColumns } from './useColumns';

import type {
  EpicProcess,
  Filters,
} from 'infrastructure/hooks/billingTools/epic/types';
import type { FC } from 'react';

interface Props {
  data: EpicProcess[] | undefined;
  count: number | undefined;
  filters: Filters;
  isLoading: boolean;
  changePage: (page: number) => void;
}

const EpicProcessesTable: FC<Props> = ({
  data,
  count,
  filters,
  isLoading,
  changePage,
}) => {
  const columns = useColumns();
  const { t } = useTranslation();

  return (
    <div>
      <BaseTableReport
        isLoading={isLoading}
        columns={columns}
        headerTitle={t('labels.epicProcesses')}
        dataSource={data}
        pagination={{
          current: filters.page,
          pageSize: filters.items,
          total: count,
          onChange: changePage,
        }}
        showCount
        anchor
      />
    </div>
  );
};

export default EpicProcessesTable;
